import React, { useState } from "react";
import "./Srchjobbanner.css";
import Nwsletter from "../Newsletter/Nwsletter";


function Newsletter() {
  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  return (
    <div className="banner-conatiner">
      <div className="banner-content">
        <div className="banner-txt">
          Want More Career Insights? <br />
        Subscribe to our newsletter and never miss an update.

        </div>
        <div className="bannen-middle"></div>
        <button className="srch-job-btn" onClick={handleOpen}>Subscribe</button>
      </div>
      <Nwsletter open={open} handleClose={handleClose} />
    </div>
  );
}

export default Newsletter